import Product from "./Product";
import Form from "./Form";

class DB {}

DB.Product = new Product();
DB.Form = new Form();

export { DB };
